import { render, staticRenderFns } from "./index.vue?vue&type=template&id=22c0d980&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHeader: require('/usr/src/motec/components/PageHeader.vue').default,WebinarsAccordionPage: require('/usr/src/motec/components/webinars/AccordionPage.vue').default})
